exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "forbidden,notfound,unauthorized{display:flex;padding:100px;justify-content:center}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./frontend/components/errors/errors.styl
 ** module id = 363
 ** module chunks = 0
 **/